import { render, staticRenderFns } from "./BranchServiceDetails.vue?vue&type=template&id=f38ea75e&"
import script from "./BranchServiceDetails.vue?vue&type=script&lang=js&"
export * from "./BranchServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38ea75e')) {
      api.createRecord('f38ea75e', component.options)
    } else {
      api.reload('f38ea75e', component.options)
    }
    module.hot.accept("./BranchServiceDetails.vue?vue&type=template&id=f38ea75e&", function () {
      api.rerender('f38ea75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/BranchServiceDetails.vue"
export default component.exports